import styled, { css } from 'styled-components';
import { SPACING_2, SPACING_16, SPACING_32, SPACING_48 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

const styles = {
  UtilityDrawer: styled.div`
    position: relative;
    flex-shrink: 0;
    ${({ height }) =>
    css`
        height: ${height};
      `}
    width: 100%;
    ${props =>
    props.$RTL &&
      css`
        direction: rtl;
      `}
  `,
  UtilityDrawerDivider: styled.div`
    height: ${SPACING_48};
    align-self: center;
    background: ${props => props.$theme.color};
    width: 0.0625rem;
    flex-shrink: 0;
  `,
  UtilityDrawerSection: styled.div`
    display: flex;
    padding: 0 ${SPACING_16};
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
  `,
  HideButtonWrapper: styled.div`
    width: fit-content;
    position: absolute;
    bottom: 0;
    min-height: 2.75rem;
    ${({ $rtl }) =>
    $rtl
      ? css`
            left: ${SPACING_16};
          `
      : css`
            right: ${SPACING_16};
          `}
    z-index: 1;
  `,
  HideButtonOverlayWrapper: styled.div`
    position: absolute;
    left: -${SPACING_2};
    border-radius: 2.125rem 2.125rem 0 0;
    height: ${SPACING_32};
    width: 2.25rem;
    overflow: hidden;
    justify-content: center;
    display: flex;
  `,
  HideButtonOverlay: styled.div`
    position: absolute;
    border-radius: ${SPACING_32} ${SPACING_32} 0 0;
    height: ${SPACING_32};
    width: ${SPACING_32};
    border-radius: ${SPACING_32} ${SPACING_32} 0 0;
    box-shadow: 0 0px ${SPACING_2} 0 rgb(0 0 0 / 25%);
  `,
  AnimationContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    ${({ height }) =>
    css`
        height: ${height};
      `}
  `,
  AnimationPlaceholder: styled.div`
    height: 100%;
    width: 100%;
  `
};

export default styles;
